import { useState, useEffect } from "react";
import { EducationIntroCard } from "./EducationIntroCard";
import "./index.css";
import readMore from "../../assets/new-education/read-more.svg";
import EducationIntroDesc from "./EducationIntroDesc";
import { useEducation } from "../../hooks/useEducation";
import { useNavigate } from "react-router-dom";
import CourseCard from "./CourseCard";
import CourseRegistrationCard from "./RegistrationCard";

const ReadMoreDetail = () => {
  const {
    courses,
    coursesLoading,
    coursesError,
    fetchMyCourses,
    fetchCourses,
    toggleFavoriteCourse,
    enrollInCourse,
  } = useEducation();
  const navigate = useNavigate();
  const [myCourses, setMyCourses] = useState([]);

  useEffect(() => {
    fetchCourses();
    loadMyCourses();
  }, []);

  const autoEnrollInCourse = async (courseId) => {
    try {
      // Check if already enrolled
      const isAlreadyEnrolled = myCourses.some(
        (course) => course.course === courseId
      );

      if (!isAlreadyEnrolled) {
        await enrollInCourse(courseId);
        // Refresh my courses list
        await fetchMyCourses();
        await loadMyCourses();
      }
    } catch (error) {
      console.error("Failed to auto-enroll in course:", error);
    }
  };

  const handleCourseClick = async (courseId) => {
    await autoEnrollInCourse(courseId);
    navigate(`/education/courses/${courseId}`);
  };

  const handleFavoriteToggle = async (e, courseId) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      // First ensure user is enrolled
      await autoEnrollInCourse(courseId);

      // Find the enrolled course
      const enrolledCourse = myCourses.find(
        (course) => course.course === courseId
      );

      if (enrolledCourse) {
        await toggleFavoriteCourse(enrolledCourse.id);
        // Refresh my courses list to get updated favorite status
        await loadMyCourses();
      }
    } catch (error) {
      console.error("Failed to toggle favorite:", error);
    }
  };

  const loadMyCourses = async () => {
    try {
      const myCoursesData = await fetchMyCourses();
      setMyCourses(myCoursesData || []);
    } catch (error) {
      console.error("Failed to load my courses:", error);
    }
  };

  if (coursesLoading) return <div>Loading courses...</div>;
  if (coursesError) return <div>Error loading courses: {coursesError}</div>;
  return (
    <div
      className="read-more-detail education-container"
      style={{ padding: "25px 32px", marginTop: "40px" }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <EducationIntroCard
          isWhite={true}
          title={"Holdundervisning"}
          icon={readMore}
          width={90}
          height={94}
        />
        <EducationIntroDesc
          title={"YFS Holdundervisning"}
          desc={
            "Læring med andre giver nye perspektiver - tag undervisning i klasserum, online eller fysisk med en underviser i Århus eller København."
          }
        />
      </div>

      <div style={{ marginTop: "55.81px" }}>
        {courses.map((course) => (
          <div style={{ display: "flex", gap: "40px", marginBottom: "20px" }}>
            <div key={course.id}>
              <CourseCard
                course={course}
                myCourses={myCourses}
                onCourseClick={handleCourseClick}
                onFavoriteToggle={handleFavoriteToggle}
              />
            </div>
            <CourseRegistrationCard />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReadMoreDetail;
